import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BookingArriveRequest } from '../pages/booking-arrive/bean/booking-arrive-request';

@Injectable({
  providedIn: 'root'
})
export class BookingArriveService {

  private logisticsBaseUrl: string = `${environment.logisticsApiUrl}/booking`;
  private whoutboundBaseUrl: string = `${environment.whOutboundApiUrl}/arrive`;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  constructor(
    private http: HttpClient
  ) { }

  checkIfBookingArrive(bookingNo: string): Observable<boolean> {
    const url = this.whoutboundBaseUrl + `/arriveConfirm/${bookingNo}`
    return this.http.get<boolean>(url, this.httpOptions)
  }

  getDoNosOfBooking(bookingNo: string): Observable<string[]> {
    const url = this.logisticsBaseUrl + `/${bookingNo}/doNoList`
    return this.http.get<string[]>(url, this.httpOptions)
  }

  uploadPOD(request: BookingArriveRequest): Observable<void> {
    const url = this.whoutboundBaseUrl + '/uploadPicture'
    return this.http.post<void>(url, request, this.httpOptions)
  }

  makeBookingArrive(request: BookingArriveRequest): Observable<void> {
    const url = this.whoutboundBaseUrl + '/bookingArrive'
    return this.http.post<void>(url, request, this.httpOptions)
  }

}
